import './App.css'
import Home from './views/Home'
import Navbar from './components/Navbar'

function App() {
  return (
    <div className="App">
      <Navbar/>
      <div className="mt-5">
        <Home></Home>
      </div>
    </div>
  );
}

export default App;
